import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { VNDialog } from '../../VNCustomerFacingDisplay/components/VNDialog'
import { getCustomerPaymentDialogOpen } from '../Selectors'
import { centsToDollars } from '../../utils/formatters'
import { setOpenCustomerPaymentDialog } from '../ActionCreators'
import { sendCFDScreenNav } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { CFD_SCREEN } from '../../VNCustomerFacingDisplay/Reducer'
import { clearOrderInProgress } from '../../actions/order'
import useRemoteOrderTotal from '../../hooks/useRemoteOrderTotal'
import { clearRemoteOrderTotal } from '../../actions/orderTotalRemote'
import { getOrderInProgress } from '../../selectors/order'
import { isTabbed, STADIUM_ORDER_STATES } from '../../utils/orderStates'
import { setCurrentPaymentFlow } from '../../VNCustomerFacingDisplay/ActionCreators'
import { CFD_POS_PAYMENT_FLOWS } from '../../VNCustomerFacingDisplay/Enums'
import { getRoundUpForCharityFeatureEnabled } from '../../selectors/menus'

/**
 *
 * @returns a dialog that either contains the title customer entering tip or confirming total depending if the tips are enabled
 */
export const VNCustomerPaymentDialog = () => {
  const dispatch = useDispatch()

  const dialogOptions = useSelector((state) => getCustomerPaymentDialogOpen(state))
  const isOpen = dialogOptions?.get('open') || false
  const orderInProgress = useSelector((state) => getOrderInProgress(state))

  const [, , resetOrderTotals] = useRemoteOrderTotal()

  const roundUpEnabled = useSelector((state) => getRoundUpForCharityFeatureEnabled(state, dialogOptions?.get('amount')))

  const getSubtitle = () => {
    if (!dialogOptions?.get('tipsEnabled') && roundUpEnabled) {
      return 'Customer Entering Donation on {{AMOUNT}}'
    }

    if (roundUpEnabled) {
      return 'Customer Entering Tip & Donation on {{AMOUNT}}'
    }

    if (dialogOptions?.get('tipsEnabled')) {
      return 'Customer Entering Tip on {{AMOUNT}}'
    }

    return 'Customer Confirming Total'
  }

  if (!isOpen) return null

  return (
    <VNDialog
      open={isOpen}
      subTitle={getSubtitle().replace('{{AMOUNT}}', centsToDollars(dialogOptions?.get('amount')))}
      primaryButtonText={'CANCEL'}
      onPrimaryButtonClick={() => {
        const tabbed = isTabbed(orderInProgress)
        const isSubmitted = orderInProgress?.state === STADIUM_ORDER_STATES.SUBMITTED

        // reset order totals
        resetOrderTotals()

        clearRemoteOrderTotal()

        if (!tabbed && !isSubmitted) {
          dispatch(clearOrderInProgress())
        }

        sendCFDScreenNav(CFD_SCREEN.CART)

        dispatch(setOpenCustomerPaymentDialog({ open: false }))
        dispatch(setCurrentPaymentFlow(CFD_POS_PAYMENT_FLOWS.UNSET, true))
      }}
    />
  )
}
